import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';
import { AVAILABLE_SCHEDULES_CONCURRENCY } from './actions/getAvailableSchedules';

export default class SubscriptionsStore {
    version = '1.0';

    subscriptions = [];
    inactiveSubscriptions = [];
    unsubscribeList = [];

    fetchedSchedules = {};
    isLoadingCard = {};
    unsubscribeProgress = {};

    connectedSchedules = {};    // { [subscriptionId]: Schedule[] } — built on getSubscriptions
    subscriptionDetails = {};   // { [subscriptionId]: flat display fields } — built on getSubscriptions

    availableSchedules = {};
    availableSchedulesLoaded = {};
    availableSchedulesExpanded = {};
    subscriptionsExpanded = {};

    // Per-card signal — ObservableMap tracks reads at key level so only the
    // affected SubscriptionCardContainer re-renders on add/remove schedule
    cardSignals = observable.map({});

    page = { number: 1, limit: 10 };

    // Tracks how much of the full result set has been loaded — built by getSubscriptions().
    pageInfo = { currentPage: 1, totalPages: 1, totalRecords: 0, totalLoaded: 0 };

    // Scoped to the "Load more" button — separate from loadProgress.subscriptions (page-wide overlay).
    loadingMoreSubscriptions = false;

    // Guard field for refreshSubscriptionsAfterDelay — not observed, plain
    // control state so a later call can cancel/replace one still pending.
    pendingRefreshTimer = null;

    availableSchedulesQueues = Array.from({ length: AVAILABLE_SCHEDULES_CONCURRENCY }, () => Promise.resolve());

    // Ids unsubscribed locally but not yet server-confirmed inactive — guards
    // the delayed refetch against the backend's slower sync (unsubscribe.js).
    pendingUnsubscribeIds = new Set();

    loadProgress = {
        // Only true while getSubscriptions() is in flight — defaulting true
        // at boot made the overlay fire before any fetch had started.
        subscriptions: false,
        syncRefresh: false,
        messageStep: 0,
        message: 'Loading',
        dots: '.',
        dotsCount: 0,
        progressLabel: 'Loading',
    };

    observed = {};

    constructor() {
        makeObservable(this, { observed: observable });
        withActions(this, actions);
    }
}

export function useSubscriptionsStore() {
    const { store } = useStores();
    return store.subscriptionsStore;
}
